import { useState, useRef, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Booking } from "@/components/Booking";
import { WhyUs } from "@/components/WhyUs";
import { Testimonials } from "@/components/Testimonials";
import { Business } from "@/components/Business";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { AdminDashboard } from "@/components/AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Home() {
  const [selection, setSelection] = useState({ pkg: null, size: "medium", extras: [] });

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const selectPackage = (id) => {
    setSelection((s) => ({ ...s, pkg: id }));
    setTimeout(() => scrollTo("prenota"), 60);
  };

  return (
    <div className="App relative">
      <Header onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Services onSelectPackage={selectPackage} />
        <Booking selection={selection} setSelection={setSelection} />
        <Business />
        <WhyUs />
        <Testimonials />
      </main>
      <Footer onNavigate={scrollTo} />
      <ChatWidget />
    </div>
  );
}

function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sid) {
        navigate("/admin");
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "X-Session-ID": sid },
          credentials: "include",
        });
        if (!res.ok) throw new Error();
        const data = await res.json();
        if (data.session_token) localStorage.setItem("cc_session_token", data.session_token);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data.user } });
      } catch (e) {
        navigate("/admin");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050B18] text-[#A0E0FF]">
      Autenticazione in corso…
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A1A3A",
            border: "1px solid rgba(126,200,227,0.4)",
            color: "#F8FAFC",
          },
        }}
      />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
